import { Component, input, computed } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-monthly-report-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: MonthlyReportTabComponent },
  ],
  templateUrl: './monthly-report-tab.component.html',
  styleUrl: './monthly-report-tab.component.scss',
})
export class MonthlyReportTabComponent extends TabComponent {
  override name = this.dictionaryService.get('MonthlyReport');

  userId = input.required<string>();
  endpoint = computed(
    () => `/visits/tables/user-monthly-report/${this.userId()}`,
  );

  public async main(): Promise<void> {}
}
